import React, { PureComponent } from 'react'
import './input.scss'

export default class Input extends PureComponent {
  static defaultProps = {
    onChange: () => {},
    placeholder: '',
    type: 'text',
    error: '',
    success: '',
    name: '',
    value: '',
    disabled: false
  }

  render() {
    const { placeholder, onChange, type, error, success, name, value, disabled, children } =
      this.props

    return (
      <div className={`input-wrap ${error ? 'error' : ''}`}>
        <input
          disabled={disabled}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          type={type}
        />

        {error && <div className='error-message'>{error}</div>}

        {success && <div className='success-message'>{success}</div>}

        {children}
      </div>
    )
  }
}
